import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Brand, UserMenu } from "@/components/Shell";

const AUTH = [
  ["Accedi", "/accedi", "home-nav-login", "bg-white/15 hover:bg-white/25"],
  ["Registrati", "/accedi?tab=registrati", "home-nav-register", "border border-white/50 hover:bg-white/15"],
  ["Area Operatori", "/accedi?area=operatori", "home-nav-operators", "bg-red-600 hover:bg-red-500"],
];

export function HomeNav({ onClinic, onServices }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const links = [["Home", () => window.scrollTo({ top: 0, behavior: "smooth" }), "home-nav-home"], ["La Clinica", onClinic, "home-nav-clinic"], ["Servizi", onServices, "home-nav-services"]];
  const go = (fn) => { setOpen(false); fn(); };
  return (
    <header className="hx-nav absolute inset-x-0 top-0 z-30 px-3 pt-3 sm:px-6 sm:pt-5" data-testid="home-nav">
      <div className="flex items-center justify-between gap-3 rounded-2xl border border-white/20 bg-slate-900/25 px-3 py-2 backdrop-blur-xl sm:px-5">
        <Brand dark />
        <nav className="hidden items-center gap-1 lg:flex">
          {links.map(([l, fn, id]) => <button key={id} data-testid={id} onClick={fn} className="rounded-full px-4 py-2 text-sm font-medium text-white/85 transition-colors hover:bg-white/10 hover:text-white">{l}</button>)}
        </nav>
        <div className="hidden items-center gap-2 lg:flex">
          {user ? <UserMenu compact /> : AUTH.map(([l, to, id, c]) => <button key={id} data-testid={id} onClick={() => navigate(to)} className={`rounded-full px-4 py-2 text-sm font-semibold text-white transition-colors ${c}`}>{l}</button>)}
        </div>
        <button data-testid="home-nav-menu" onClick={() => setOpen(!open)} aria-label="Menu" className="grid h-10 w-10 place-items-center rounded-full bg-white/15 text-white lg:hidden">{open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}</button>
      </div>
      {open && (
        <div className="mt-2 space-y-1 rounded-2xl border border-white/20 bg-slate-900/70 p-3 backdrop-blur-xl lg:hidden" data-testid="home-nav-mobile">
          {links.map(([l, fn, id]) => <button key={id} data-testid={`${id}-m`} onClick={() => go(fn)} className="block w-full rounded-xl px-4 py-3 text-left text-sm font-medium text-white hover:bg-white/10">{l}</button>)}
          <div className="grid gap-2 border-t border-white/15 pt-3">
            {user ? <UserMenu compact /> : AUTH.map(([l, to, id, c]) => <button key={id} data-testid={`${id}-m`} onClick={() => navigate(to)} className={`rounded-full px-4 py-3 text-sm font-semibold text-white ${c}`}>{l}</button>)}
          </div>
        </div>
      )}
    </header>
  );
}
